let debounceTimer;

function debounce(func, delay) {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(func, delay);
}

function updateAllSliderHeights() {
  document.querySelectorAll(".main-slider.slider--adapt-to-image").forEach(slider => {
    const img = slider.querySelector(".swiper-slide:first-child img");
    if (!img) return;

    const setHeight = () => {
      const realHeight = img.naturalHeight / img.naturalWidth * slider.offsetWidth;
      slider.style.height = realHeight + "px";
    };

    if (img.complete) {
      setHeight();
    } else {
      img.addEventListener("load", setHeight, { once: true });
    }

    window.addEventListener("resize", setHeight);
  });
}

function initializeMainSlider() {
  debounce(() => {
    const mainSliderElements = document.querySelectorAll(".main-slider");

    mainSliderElements.forEach(sliderElement => {
      const enableImageAdaptation = sliderElement.dataset.adaptToImage === "true"; 
      if (sliderElement.swiper) {
        sliderElement.swiper.destroy(true, true);
      }

      const enableAutoplay = sliderElement.dataset.enableAutoplay === "true";
      const autoplaySpeedSeconds = parseFloat(sliderElement.dataset.autoplaySpeed) || 3;
      const autoplaySpeedMilliseconds = autoplaySpeedSeconds * 1000;
      const sliderDirection = sliderElement.dataset.sliderDirection;
      const sliderLoop = sliderElement.dataset.sliderLoop === "true";

      const mainSliderOptions = {
        loop: sliderLoop,
        speed: 1000,
        direction: sliderDirection,
        parallax: true,
        grabCursor: true,
        watchSlidesProgress: true,
        autoplay: enableAutoplay ? { delay: autoplaySpeedMilliseconds, disableOnInteraction: true } : false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
        },
        focusableElements: 'input, select, option, textarea, button, video, label', 
        on: {
          init: function () {
          const swiper = this;
            
          const activeSlide = swiper.slides[swiper.activeIndex];
          const title = activeSlide.querySelector(".title");
          if (title) title.classList.add("show");

          const captionBox = activeSlide.querySelector(".caption-box");
          if (captionBox) captionBox.classList.add("show");

          const caption = activeSlide.querySelector(".caption");
          if (caption) caption.classList.add("show");

          const bannerButtons = activeSlide.querySelector(".banner-buttons");
          if (bannerButtons) bannerButtons.classList.add("show");

          if (swiper.autoplay && enableAutoplay) {
            swiper.autoplay.start();
          }
            if (enableImageAdaptation) {
              updateAllSliderHeights();
            }
          },
          slideChangeTransitionEnd: function () {
            let swiper = this,
              captions = swiper.el.querySelectorAll(".caption, .banner-buttons");
            for (let i = 0; i < captions.length; ++i) {
              captions[i].classList.remove("show");
            }
            let activeSlide = swiper.slides[swiper.activeIndex];

            let caption = activeSlide.querySelector(".caption");
            if (caption) {
              caption.classList.add("show");
            }

            let bannerButtons = activeSlide.querySelector(".banner-buttons");
            if (bannerButtons) {
              bannerButtons.classList.add("show");
            }
          },
          touchStart: function () {
            let swiper = this;
            for (let i = 0; i < swiper.slides.length; i++) {
              swiper.slides[i].style.transition = "";
            }
          },
        },
      };

      // Initialize Swiper
      new Swiper(sliderElement, mainSliderOptions);
    });
  }, 300); 
}
window.addEventListener("resize", () => {
  initializeMainSlider();
});

initializeMainSlider();
